import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, ReplaySubject, of } from 'rxjs';

import { CookieName } from '../browser/cookie/cookie.models';
import { CookieService } from '../browser/cookie/cookie.service';
import { Page } from '../client-config/page.client-config';
import { SharedFeaturesApiService } from '../http/shared-features-api.service';
import { RememberMeConfig } from './remember-me.client-config';

/**
 * @stable
 */
@Injectable({
    providedIn: 'root',
})
export class RememberMeService {
    retryNotifier: ReplaySubject<HttpErrorResponse | null> | null = null;

    private readonly rememberMeConfig = inject(RememberMeConfig);
    private readonly cookieService = inject(CookieService);
    private readonly page = inject(Page);
    private readonly sharedFeaturesApiService = inject(SharedFeaturesApiService);

    private get url(): string {
        return `${this.rememberMeConfig.apiHost.replace(/\/+$/, '')}/api/auth/rememberme?culture=${this.page.lang}`;
    }

    tokenExists(): boolean {
        return this.rememberMeConfig.isEnabled ? !!this.cookieService.get(CookieName.RmI) : false;
    }

    rememberMeEnabledInPast(): boolean {
        return this.rememberMeConfig.isEnabled ? !!this.cookieService.get(CookieName.RmH) : false;
    }

    authTokenExists(): boolean {
        return !!this.cookieService.get(CookieName.VnAuth);
    }

    setupTokenAfterLogin(): Observable<void> {
        if (!this.rememberMeConfig.isEnabled) {
            return of();
        }

        return this.sharedFeaturesApiService.put(this.url, null, { keepalive: true });
    }

    login(data: any): Observable<any> {
        return this.sharedFeaturesApiService.post(this.url, data, { keepalive: true });
    }

    logout(): Observable<void> {
        return this.sharedFeaturesApiService.delete(this.url, null, { keepalive: true });
    }
}
